import http from '@/http-common'
import global from '../../utils/global'
import Title from "@/components/TitlePage.vue";

export default {
  name: 'RequestTab',
  components: {Title},
  props: {
    showCaption: {
      type: Boolean,
      default: true,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    captionTab: {
      type: String,
      default: true,
    },
    items: {
      type: Array,
      default: []
    },
    columns: {
      type: Array,
      default: []
    },
    isCalled: {
      type: Boolean,
      default: false,
    },
    isViewBtn: {
      type: Boolean,
      default: true,
    },
    selectValue: {
      type: Object,
      default: null
    },
    urls: {
      type: Object,
      default: function () {
        return {
          save: '',
          delete: ''
        }
      }
    },
    captionSpr: {
      type: Object,
      default: null
    },
    filter: {
      type: Object,
      default: null,
    },
    limitFed: {
      type: Number,
      default: 0
    },
    summRecord: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getBack() {
      return "background: rgba(255, 255, 150, 0.8);"
    },
    getColor() {
      return "theadColor"
    },
    titleSpr: function () {
      return "Добавить " + this.captionSpr.nameR
    },
    widthCol: function () {
      return {
        'col-md-4': this.isCalled,
        'col-md-3': !this.isCalled,
      }
    },
    classRow: function () {
      return {
        'col-xs-12 col-sm-12 col-md-12 col-lg-12': this.isCalled,
        'col-xs-12 col-sm-12 col-md-12 col-lg-10': !this.isCalled
      }
    }
  },
  data() {
    return {
      stacked: {
        flg: false,
        size: 'md'
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      pageOptions: [10, 15, 20],
      selectMode: 'single',
      selected: [],
      selectedItem: {id: null},
      confirm_dialog: false,
      countRows: 0,
      comments: [
        {key: 'Замечание'}
      ],
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  created() {
    this.totalRows = this.items.length;
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  watch: {
    selectedItem: function (val) {
      if (val !== false) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onResize() {
      // Small (sm) <=540px
      if (document.documentElement.clientWidth > global.isMobileWidth()) {
        this.stacked.flg = false
        this.stacked.size = 'sm'
        this.columns.forEach(function (x) {
          x.class = x.firstClass;
        })
      } else {
        this.stacked.flg = true
        this.stacked.size = 'sm'
        this.columns.forEach(function (x) {
          x.class = null;
        })
      }
    },
    getStacked() {
      if (this.stacked.flg) {
        return this.stacked.size;
      } else {
        return false;
      }
    },
    rowSelected(items) {
      this.selected = items;
      //var rec = this.selectedItem;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      //this.selectedItem = rec;
      this.$emit('input', this.selectedItem)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1
      this.$emit('onFiltered', filteredItems)
    },
    cleanItem() {
      for (var key in this.selectedItem) {
        if (typeof this.selectedItem[key] === 'string') {
          this.selectedItem[key] = null
        } else if (typeof this.selectedItem[key] === 'array') {
          this.selectedItem[key] = []
        } else {
          this.selectedItem[key] = null
        }
      }
    },
//            add() {
//                if (this.items.length > 0)
//                    this.rowSelected([this.items[0]]);
//                this.cleanItem();
//                this.selectedItem.stateRequest='NEW'
//                this.$emit('editItem')
//            },
    save(rec) {
      var id_rec = this.selectedItem.id;
      var data = rec;
      var vm = this;
      var token = localStorage.getItem('token');
      http.post(this.urls.save, data, {headers: {Authorization: 'Bearer_' + token}})
      .then((res) => {
        var result = res.data;
        if (result.id > 0) {
          const index = vm.items.map(e => e.id).indexOf(result.id);
          if (index >= 0) {
            for (var key in result) {
              vm.items[index][key] = result[key];
            }
          }
        } else {
          alert("Ошибка согласования позиции!!!")
        }
      }).catch(function (error) {
        if (error.response.status === 403) {
          alert("Нет прав!")
        } else {
          alert("Ошибка согласования!!!")
        }
      })
    },
    deleteItem() {
      var vm = this
      var data = this.selectedItem;
      if (!this.selectedItem.errorStr || this.selectedItem.errorStr.length === 0) {
        alert("Укажите причину отказа!")
      } else {
        var token = localStorage.getItem('token');
        http.post(this.urls.delete, data, {headers: {Authorization: 'Bearer_' + token}})
        .then((res) => {
          var dataR = res.data;
          if (dataR.id > 0) {
            const index = vm.items.map(e => e.id).indexOf(dataR.id);
            if (index >= 0) {
              for (var key in dataR) {
                vm.items[index][key] = dataR[key];
              }
            }
            vm.confirm_dialog = false;
            vm.$emit('closeEdit')
          } else {
            if (dataR.error_mess) {
              alert(dataR.error_mess)
            } else {
              alert("Ошибка сохранения!!!")
            }
          }
        }).catch(function (error) {
          if (error.response.status == 403) {
            alert("Нет прав!")
          } else {
            alert("Ошибка сохранения на сервере!!!")
          }
        })
      }
    },
    showConfirmDlg(rec) {
      this.rowSelected([rec]);
      this.confirm_dialog = true;
    },
    editSpr(rec) {
      this.rowSelected([rec]);
      this.$emit('editItem')
    },
//            updateData() {
//                this.$emit('updateData')
//            },
    getColorCell(item) {
      if (item.colorBackground || item.colorFont) {
        return 'background: ' + item.colorBackground + '; color: ' + item.colorFont;
      } else {
        return ''
      }
    },
    tdClass(value, key, item) {
      switch (item.stateRequest) {
        case 'NEW':
          return 'bg-secondary';
          break;
        case 'SUCCESS':
          return 'successClass';
          break;
        case 'DELETED':
          return 'bg-danger text-light';
          break;
      }
    },
    filterFunction(row, val) {
      const {selectedStatusId: status, other: p} = val;
      return [
        !status || status === row.stateRequest,
        !p || row.nameEvent.toUpperCase().indexOf(p.toUpperCase()) >= 0 ||
        //row.organization.toUpperCase().indexOf(p.toUpperCase()) >= 0 ||
        row.federation.toUpperCase().indexOf(p.toUpperCase()) >= 0 ||
        row.location.toUpperCase().indexOf(p.toUpperCase()) >= 0 ||
        row.jobKind.toUpperCase().indexOf(p.toUpperCase()) >= 0 ||
        row.sportKind.toUpperCase().indexOf(p.toUpperCase()) >= 0,
      ].every(Boolean);
    },
  }
}
